import React from 'react';
import { NiceFormGroup } from './Components.styles';

const YearPicker = ({
	startYear = 2000,
	endYear = new Date().getFullYear(),
	label,
	onChange,
	name,
	value,
	required,
}) => {
	// Create an array of years between startYear and endYear
	const years = [];
	for (let year = startYear; year <= endYear; year++) {
		years.push(year);
	}

	return (
		<NiceFormGroup>
			<label htmlFor="year-picker">{label}</label>
			<select
				id="year-picker"
				value={value}
				onChange={onChange}
				style={{ width: '350px' }}
				name={name}
				required={required}
				placeholder={'Select Year'}
			>
				<option hidden> -- select an option -- </option>
				{years.map(year => (
					<option key={year} value={year}>
						{year}
					</option>
				))}
			</select>
			{/* <p>Selected Year: {selectedYear}</p> */}
		</NiceFormGroup>
	);
};

export default YearPicker;
